<div class="characterisation-status">
  <div class="status-graph">
    <a href="/assets/gene_characterisation_status_figure.svg" title="Gene characterisation status">
      <img src="/assets/gene_characterisation_status_figure.svg" />
    </a>
  </div>

  <div class="status-table">
  <app-loading-spinner *ngIf="!characterisationSubsets && !apiError"></app-loading-spinner>
  <app-api-error-display *ngIf="apiError" [error]="apiError"></app-api-error-display>

  <table *ngIf="characterisationSubsets">
    <thead>
      <tr>
        <th>&nbsp;</th>
        <th class="content">Gene status overview</th>
        <th class="content">Annotated</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let subset of characterisationSubsets">
        <td [class]="'colour-patch ' + subset.elClass || '#0000'"></td>
        <td class="content" title="{{subset.title || subset.displayName}}">
          <span *ngIf="subset.name == 'Sub total'"><span class="total">{{subset.displayName}}</span> (proteome size)</span>
          <span *ngIf="subset.name != 'Sub total'">{{subset.displayName}}</span>
        </td>
        <td class="content">
          <span class="total" *ngIf="subset.name == 'Sub total'">{{subset.geneCount}}</span>
          <a *ngIf="subset.name != 'Sub total'" routerLink="/gene_subset/{{subset.name}}">{{subset.geneCount}}</a>
        </td>
      </tr>
      <tr>
        <td>&nbsp;</td>
        <td class="content"><span class="total">Total</span></td>
        <td class="content"><span class="total">{{total}}</span></td>
      </tr>
    </tbody>
  </table>
  </div>
</div>
